export default function seo(data = {}) {
  data.title = data.title + ' — The Olde Barber Cannabis Co.' || 'The Olde Barber Cannabis Co.';
  data.metaDescription = data.metaDescription || 'Cannabis in Cobalt, Temiskaming Shores, New Liskeard, Haileybury, Latchford, Earlton';

  document.title = data.title;
  document.querySelector('meta[name="description"]').setAttribute('content', data.metaDescription);
}